import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './AddInfo.css';
import Plus from '../assets/PlusButton';
import PlusGrey from '../assets/PlusButtonGrey';

const AddInfo = ({ onClick, disabled }) => (
  <button className={styles.buttonStyle} onClick={onClick} disabled={disabled}>
    <div className={styles.plus}>{disabled ? <PlusGrey /> : <Plus />}</div>
  </button>
);

AddInfo.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default AddInfo;



// WEBPACK FOOTER //
// ./src/components/AddInfo.jsx